<script>
/**
 * Login component
 */
export default {
    data() {
        return {
            email: "",
            password: "",
            tryingToLogIn: false,
            isAuthError: false,
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        };
    },
    props: {
        submitUrl: {
        type: String,
        required: true
        },
        authError: {
        type: String,
        required: false,
        default: () => null
        }
    },
    mounted() {
        this.isAuthError = !!this.authError;
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods:{
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            console.log(this.windowWidth);
            console.log(this.windowHeight);
        },
    },
    created(){
        this.handleResize();
    }
};
</script>
<template>
    <div class="containerlogin">
        <div class="rectangle" v-if="windowWidth>576">
            <div class="half left pt-5">
                <div class="logo-center">
                    <img src="/images/logos/LogoAtaraxia.webp" alt="" class="it">
                    <p class="text-white text viga-regular">www.alegoria.cl</p>
                </div>
            </div>
            <div class="half right p-5">
                <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>
                <b-form class="p-2" :action="submitUrl" method="POST">
                    <slot />
                    <h4 class="text-white pt-login bakbak-one-regular">Inicio de sesión</h4>
                    <div class="pt-5">
                        <b-form-group id="input-group-1" label-for="input-1">
                            <b-form-input id="input-1" class="input-with-border" name="email" v-model="email" type="text" placeholder="Usuario"></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-2" label-for="input-2">
                            <b-form-input id="input-2" class="input-with-border" v-model="password" name="password" type="password" placeholder="Contraseña"></b-form-input>
                        </b-form-group>
                        <div class="row">
                            <div class="col-md-5 pt-2">
                                <div class="custom-control custom-checkbox">
                                    <input id="customControlInline" type="checkbox" class="custom-control-input" />
                                    <label class="custom-control-label font-size-9 text-white viga-regular" for="customControlInline">Recordar mi usuario</label>
                                </div>
                            </div>
                            <div class="col-md-7 text-right pt-2">
                                <a href="/password/reset" class="text-white font-size-9 viga-regular">
                                    <i class="mdi mdi-lock mr-1"></i> ¿Haz olvidado tu contraseña?
                                </a>
                            </div>
                            <div class="offset-md-2 col-md-8 mt-5 pt-4">
                                <b-button type="submit"  pill class="btn-block btn-login viga-regular">Ingresar</b-button>
                            </div>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
        <div v-else>
            <div class="half p-5">
                <div class="">
                    <img src="/images/logos/LogoAtaraxia.webp" alt="">
                    <p class="text-white text-center">www.alegoria.cl</p>
                </div>
                <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>
                <b-form class="pt-3" :action="submitUrl" method="POST">
                    <slot />
                    <h4 class="text-white bakbak-one-regular">Inicio de sesión</h4>
                    <div class="pt-2">
                        <b-form-group id="input-group-1" label-for="input-1">
                            <b-form-input id="input-1" class="input-with-border" name="email" v-model="email" type="text" placeholder="Usuario"></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-2" label-for="input-2">
                            <b-form-input id="input-2" class="input-with-border" v-model="password" name="password" type="password" placeholder="Contraseña"></b-form-input>
                        </b-form-group>
                        <div class="row">
                            <div class="col-md-5 pt-2">
                                <div class="custom-control custom-checkbox">
                                    <input id="customControlInline" type="checkbox" class="custom-control-input" />
                                    <label class="custom-control-label font-size-9 text-white viga-regular" for="customControlInline">Recordar mi usuario</label>
                                </div>
                            </div>
                            <div class="col-md-7 text-right pt-2">
                                <a href="/password/reset" class="text-white font-size-9 viga-regular">
                                    <i class="mdi mdi-lock mr-1"></i> ¿Haz olvidado tu contraseña?
                                </a>
                            </div>
                            <div class="offset-md-2 col-md-8 mt-5 pt-4">
                                <b-button type="submit"  pill class="btn-block btn-login viga-regular">Ingresar</b-button>
                            </div>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<style scoped>
</style>